var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Prop, Watch } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseFollowService } from "~/services/domain-service/case-follow.service";
import { CaseFollowRecordService } from "~/services/business-service/case-follow-record.service";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import ViewRecoredFiles from "./view-recored-files.vue";
var collectionManageModule = namespace("collection-manage");
var AddressFollowQuery = /** @class */ (function (_super) {
    __extends(AddressFollowQuery, _super);
    function AddressFollowQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = { state: false };
        _this.currentCase = {};
        _this.dialog = {
            certificate: false,
            record: false,
            video: false,
            recordFiles: false
        };
        _this.dataSet = [];
        _this.followQuery = {
            certificateNo: "",
            collectionWay: 1,
            type: "ADDR",
            personalId: ""
        };
        return _this;
    }
    AddressFollowQuery.prototype.onCaseIdChanged = function (val) {
        val && this.refreshData();
    };
    AddressFollowQuery.prototype.cellStyle = function (row) {
        if (row.row.contactResult === "承诺还款" && row.columnIndex == 2) {
            return { color: '#fc8144 !important' };
        }
        if (row.row.contactResult === "已还款" && row.columnIndex == 2) {
            return { color: '#00c100 !important' };
        }
    };
    AddressFollowQuery.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.followQuery.certificateNo = this.certificateNo;
        // this.followQuery.personalId = this.personalId;
        this.caseFollowRecordService
            .getAllCaseFollowRecord(this.followQuery, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    AddressFollowQuery.prototype.activated = function () {
        this.refreshData();
    };
    /**
     *下载
     */
    AddressFollowQuery.prototype.downLoadFile = function (follow, type) {
        var _this = this;
        this.currentCase = follow;
        var data = type === 2 ? this.currentCase.record : this.currentCase.video;
        data.forEach(function (x) {
            _this.uploadFileService
                .getFileStreamById(x.id, x.fileName)
                .subscribe(function () { return _this.$message.success("下载成功"); });
        });
    };
    /**
     *查看看凭证
     */
    AddressFollowQuery.prototype.certificateDetails = function (follow, type) {
        this.currentCase = follow;
        if (type === 1) {
            this.dialog.certificate = true;
        }
        else if (type === 2) {
            this.dialog.record = true;
        }
        else {
            this.dialog.video = true;
        }
    };
    AddressFollowQuery.prototype.viewRecordFiles = function (row) {
        this.currentCase = row;
        this.dialog.recordFiles = true;
    };
    __decorate([
        Dependencies(PageService)
    ], AddressFollowQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AddressFollowQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseFollowService)
    ], AddressFollowQuery.prototype, "caseFollowService", void 0);
    __decorate([
        Dependencies(CaseFollowRecordService)
    ], AddressFollowQuery.prototype, "caseFollowRecordService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], AddressFollowQuery.prototype, "uploadFileService", void 0);
    __decorate([
        Prop({
            required: true,
            default: ""
        })
    ], AddressFollowQuery.prototype, "certificateNo", void 0);
    __decorate([
        Prop({ required: true, default: "" })
    ], AddressFollowQuery.prototype, "personalId", void 0);
    __decorate([
        Watch("certificateNo", { immediate: true })
    ], AddressFollowQuery.prototype, "onCaseIdChanged", null);
    AddressFollowQuery = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                ViewRecoredFiles: ViewRecoredFiles
            }
        })
    ], AddressFollowQuery);
    return AddressFollowQuery;
}(Vue));
export default AddressFollowQuery;
